import { useCallback, useState } from 'react'
import * as Api from 'apps/fleet-planner/utils/api'
import { ILoad, ILoadsParams } from '../types'

/**
 * Hook for fetching/storing load data and state
 * @see https://fp-staging.transfix.io/api-docs/index.html
 */
export const useLoadsApi = () => {
  const [isLoading, setLoading] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const [loadsList, setLoadsList] = useState<ILoad[]>([])
  const [error, setError] = useState<string | undefined>()
  const resetError = useCallback(() => setError(''), [])

  /**
   * Fetch loads data + return the loads list
   */
  const getLoads = useCallback(async (params: ILoadsParams): Promise<ILoad[] | undefined> => {
    setError('')
    setLoading(true)
    try {
      const { shipments: response, totalCount: totalFacilitiesCount } = await Api.getLoads(params)
      setLoadsList(response)
      setTotalCount(totalFacilitiesCount)
      setLoading(false)
      return response
    } catch (e) {
      setError(e)
      setLoading(false)
      return undefined
    }
  }, [])

  return {
    isLoading,
    error,
    getLoads,
    loadsList,
    totalCount,
    resetError,
  }
}
